import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import ButtonBase from '../ButtonBase';

const Button = ({ children, textFontFamily, color, hoverColor, borderRadius, ...otherProps }) => (
  <ButtonWrapper
    {...otherProps}
    textFontFamily={textFontFamily}
    color={color}
    hoverColor={hoverColor}
    borderRadius={borderRadius}
  >
    {children}
  </ButtonWrapper>
);
Button.propTypes = {
  children: PropTypes.node,
  textFontFamily: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  borderRadius: PropTypes.number
};

Button.defaultProps = {
  textFontFamily: '"Lato", sans-serif'
};

const ButtonWrapper = styled(ButtonBase)`
  position: relative;
  padding: 8px 16px;
  font-family: ${({ textFontFamily }) => textFontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ color }) => `${color}`};
  border: 1px solid ${({ color }) => `${color}`};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  transition: color 0.2s ease-in-out, background-color 0.3s ease-in-out;

  :hover {
    color: ${({ hoverColor }) => `${hoverColor}`};
    background-color: ${({ color }) => `${color}`};
  }
`;

export default Button;
